export const formatPaymentMethodChartData = (
  bookedBookings,
  cancelledBookings
) => {
  const bookedPaymentMethods = bookedBookings.reduce((acc, booking) => {
    const paymentMethod = booking.paymentMethod || "Unknown";
    acc[paymentMethod] = (acc[paymentMethod] || 0) + 1;
    return acc;
  }, {});
  const cancelledPaymentMethods = cancelledBookings.reduce((acc, booking) => {
    const paymentMethod = booking.paymentMethod || "Unknown";
    acc[paymentMethod] = (acc[paymentMethod] || 0) + 1;
    return acc;
  }, {});

  const allPaymentMethods = [
    ...new Set([
      ...Object.keys(bookedPaymentMethods),
      ...Object.keys(cancelledPaymentMethods),
    ]),
  ];
  const sortedPaymentMethods = allPaymentMethods.sort((a, b) => {
    const totalA =
      (bookedPaymentMethods[a] || 0) + (cancelledPaymentMethods[a] || 0);
    const totalB =
      (bookedPaymentMethods[b] || 0) + (cancelledPaymentMethods[b] || 0);
    return totalB - totalA;
  });

  const bookedData = sortedPaymentMethods.map(
    (paymentMethod) => bookedPaymentMethods[paymentMethod] || 0
  );
  const cancelledData = sortedPaymentMethods.map(
    (paymentMethod) => cancelledPaymentMethods[paymentMethod] || 0
  );

  return {
    labels: sortedPaymentMethods,
    datasets: [
      {
        label: "Booked",
        data: bookedData,
        backgroundColor: "rgba(0, 128, 128, 0.6)",
        borderColor: "rgba(0, 128, 128, 1)",
        borderWidth: 1,
      },
      {
        label: "Cancelled",
        data: cancelledData,
        backgroundColor: "rgba(0, 102, 204, 0.6)",
        borderColor: "rgba(0, 102, 204, 1)",
        borderWidth: 1,
      },
    ],
  };
};
